<template>
  <div class="dynamic-layout">
    <div v-for="(item,index) in dynamicData" :key="index" class="flex-column dynamic-item">
      <p class="item-title-text flex text-left"><span class="icon"/><span class="text">
        {{ item.title }}<a style="color: #999999;margin-left: 10px;cursor: auto">{{ item.date }}</a></span></p>
<!--      <p class="item-time text-left"><i class="el-icon-time"></i>{{ item.date }}</p>-->
    </div>
    <p class="dynamic-more pointer">查看更多</p>
  </div>
</template>

<script>
export default {
  name: "dynamicList",
  data() {
    return {
      dynamicData:[
          {title:'性能秒杀Intel、NVIDIA！离谱的“万能CPU”升级192核心！',date:'2023-08-18'},
          {title:'400亿交易告吹 Intel雄心不变：2030前成第二大芯片代工厂',date:'2023-08-17'},
          {title:'比A/N更新还勤快 Intel发布新显卡驱动：修复光追卡死bug',date:'2023-08-17'},
          {title:'未获中国批准！Intel 400亿元重磅收购告吹：分手费25.8亿',date:'2023-08-16'},
          {title:'Intel CEO喊话美国政府：必须放宽对中国限制',date:'2023-08-16'},
      ]
    }
  },
  created() {
  },
  methods: {}
}
</script>

<style scoped lang="less">
.dynamic-layout{
  padding: 6px;
  .dynamic-item{
    margin: 10px 0;
    .item-title-text{
      .icon{
        margin-top: 4px;
        height: 12px;
        width: 14px;
        border-radius: 50%;
        border: 4px solid #B3CFEF;
      }
      .text{
        margin-left: 6px;
        color: #333333;
        font-weight: 500;
      }
    }
    .item-time{
      padding-left: 20px;
      margin-top: 3px;
      color: #999999;
      i{
        width: 13px;
        height: 13px;
        margin-right: 5px;
      }
    }
  }

  .dynamic-more{
    margin: 20px;
    border: 1px solid #0055B3;
    padding: 10px 0;
    color: #0055B3;
  }
}
</style>
